import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import '../styles/Header.css';
import logo from '../assets/5n1pr_ileti_im_dan_manl__logox.jpeg';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container header-container">
        <div className="logo">
          <Link to="/" onClick={closeMobileMenu}>
            <img src={logo} alt="5N1PR İletişim Danışmanlığı" />
          </Link>
        </div>

        <div className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink to="/" className="nav-link" onClick={closeMobileMenu}>
                Ana Sayfa
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/hakkimizda" className="nav-link" onClick={closeMobileMenu}>
                Hakkımızda
              </NavLink>
            </li>
            <li className="nav-item dropdown">
              <NavLink to="/hizmetlerimiz" className="nav-link" onClick={closeMobileMenu}>
                Hizmetlerimiz
              </NavLink>
              <ul className="dropdown-menu">
                <li>
                  <Link to="/hizmetlerimiz/pr" className="dropdown-item" onClick={closeMobileMenu}>
                    PR
                  </Link>
                </li>
                <li>
                  <Link to="/hizmetlerimiz/sosyal-medya" className="dropdown-item" onClick={closeMobileMenu}>
                    Sosyal Medya
                  </Link>
                </li>
                <li>
                  <Link to="/hizmetlerimiz/produksiyon" className="dropdown-item" onClick={closeMobileMenu}>
                    Prodüksiyon
                  </Link>
                </li>
                <li>
                  <Link to="/hizmetlerimiz/organizasyon" className="dropdown-item" onClick={closeMobileMenu}>
                    Organizasyon
                  </Link>
                </li>
                <li>
                  <Link to="/hizmetlerimiz/studyo-hizmeti" className="dropdown-item" onClick={closeMobileMenu}>
                    Stüdyo Hizmeti
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <NavLink to="/iletisim" className="nav-link" onClick={closeMobileMenu}>
                İletişim
              </NavLink>
            </li>
          </ul>
        </div>

        <button className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`} onClick={toggleMobileMenu}>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
      </div>
    </header>
  );
};

export default Header;